import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import 'react-day-picker/lib/style.css'
import { SearchOutlined } from '@ant-design/icons'
import { Select, Button } from 'antd'
import { Formik, ErrorMessage } from 'formik'
import { Form, DatePicker, Field } from 'formik-antd'
import { MultiSelect } from 'primereact/multiselect'
import Draggable from 'react-draggable'
import Modal from 'react-bootstrap/Modal'
import DraggableModalDialog from '../common/DraggableModalDialog'
import { formatDate, parseDate } from 'react-day-picker/moment'
import ModalSMS from '../settings/ModalSMS'

// import TimePicker from 'react-times';
import moment from 'moment'

// CSS
import './ETimeForm.css'

import validate from './validation/validate-yup'
import getValidationSchema from './validation/getValidationSchema-yup'
import TimeUtils from '../../utils/TimeUtils'

const { RangePicker } = DatePicker

class EmployeeSelector extends PureComponent {
    handleChange = value => {
        // this is going to call setFieldValue and manually update values.topcis
        this.props.onChange('employee', value)
    }

    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched.topcis
        this.props.onBlur('employee', true)
    }

    render() {
        const customClass = this.props.className

        const doropdownClass =
            'form-control-select dropdownselect ' + customClass

        return (
            <div style={{ margin: '0rem 0' }}>
                <Select
                    id="employee"
                    className={doropdownClass}
                    // multi={false}
                    options={this.props.options}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={this.props.value}
                    // isSearchable={false}
                    isDisabled={this.props.readOnly}
                />
                <div className="errorMsg">
                    <ErrorMessage name="employee" />
                </div>
            </div>
        )
    }
}

class ETimeForm extends PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        selectedOption: null,
        loaded: false,
        events: [],
        showModal: false,
        showNotifyWindow: false,
        hourStart: null,
        minuteStart: null,
        meridiemStart: null,
        focusedStart: false,
        timezoneStart: null,
        showTimezoneStart: false,
        hourEnd: null,
        minuteEnd: null,
        meridiemEnd: null,
        focusedEnd: false,
        timezoneEnd: null,
        showTimezoneEnd: false,
        showTimeSelector: false,
        showDuration: false,
        show: false,
        disableRemove: false,
        employee: '',
        event: {},
        actions: {},
        readOnly: false,
        leaveType: false,
        multipleDays: false,
        currentEmployee: null,
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    componentWillReceiveProps = props => {
        this.setState(props)
    }
    componentDidMount() {
        // disableRemove = _.isEmpty(this.props.event.id)
        this.setState({ disableRemove: _.isEmpty(this.props.event.id) })
        const actionTypeElm = document.getElementById('actionType')
        // actionTypeElm.getElementsByTagName('input')[0].readOnly = true

        // disable update by action type == 14 (normal work)
        const user = JSON.parse(localStorage.getItem('user'))
        if (user.role !== 0) {
            const actionType = this.props.event.actionType.value
            if (99 == actionType && this.props.event.existing) {
                // disable update
                this.setState({ readOnly: true })
            }
        }

        if (this.props.readOnly) {
            this.setState({ readOnly: true })
        }

        if (this.props.event.source === 'timesheet') {
            this.setState({ readOnly: true })
        }

        const leave = this.props.event.actionType.value < 99 ? true : false
        this.setState({ leaveType: leave })
    }

    onTimeChangeStart = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourStart: hour,
            minuteStart: minute,
            meridiemStart: meridiem,
        })
    }

    onFocusChangeStart = focusedStart => {
        this.setState({ focusedStart })
    }

    onTimeChangeEnd = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourEnd: hour,
            minuteEnd: minute,
            meridiemEnd: meridiem,
        })
    }

    onFocusChangeEnd = focusedEnd => {
        this.setState({ focusedEnd })
    }

    // handleActionTypeChange = selectedOption => {
    //     this.setState({ selectedOption })
    //     console.log(`Option selected:`, selectedOption)
    // }

    castToViewModel = (data, employeeId) => {
        const vm = {}
        vm.id = this.props.event.id || ''
        vm.Title = data.title

        // const start = _.head(data.range)
        // const end = _.last(data.range)
        // vm.StartDate = moment(TimeUtils.combineDateNTime(start, data.startTime))
        // vm.EndDate = moment(TimeUtils.combineDateNTime(end, data.endTime))
        vm.StartDate = data.startDate
        vm.EndDate = data.endDate
        vm.ActionType = data.actionType.value
        vm.ActionHours = data.duration
        vm.allDay = true
        vm.Note = data.note
        vm.Status = 'edit'
        vm.Break = data.break
        vm.EmployeeID = employeeId
        vm.Hours = data.hours

        return vm
    }

    castToViewModelMulti = (data, selectedEmployees) => {
        const vm = {}
        vm.id = this.props.event.id || ''
        vm.StartDate = data.startDate
        vm.EndDate = data.endDate
        vm.ActionType = data.actionType.value
        vm.ActionHours = data.duration
        vm.allDay = true
        vm.Note = data.note
        vm.Status = 'edit'
        vm.Break = data.break
        vm.employees = selectedEmployees
        vm.Hours = data.hours
        vm.employeeID = data.employeeID

        return vm
    }

    handleETimeSubmit = (data, setSubmitting) => {
        const { renderContent } = this.props
        let employeeId = this.props.employee
        if (renderContent === 'roster') {
            // employeeId = _.first(data.employee)['value']
            if (_.isEmpty(employeeId)) {
                employeeId = this.props.event.employeeID
            }
        } else {
            employeeId = data.employee.value
        }

        const actinType = data.actionType.value
        // actionType >= 99 normal
        // otherwise leave
        if (actinType < 99) {
            const start = _.head(data.range)
            const end = _.last(data.range)
            data.startDate = start
            data.endDate = end

            if (!moment(start).isSame(end, 'day')) {
                data.hours = this.props.payrollDefaultWorkHour[employeeId]
            }
        } else {
            const start = _.head(data.range)
            const end = _.last(data.range)
            data.startDate = moment(
                TimeUtils.combineDateNTime(start, data.startTime)
            )
            data.endDate = moment(TimeUtils.combineDateNTime(end, data.endTime))
        }

        // display title
        // actionType >= 99

        // format title HH:MM - HH:MM : EmployeeName

        let title = ''
        if (actinType < 99) {
            // format EmployeeName
            if (renderContent === 'roster') {
                const emp = _.find(this.props.employees, {
                    EmployeeAutoID: employeeId,
                })
                title = `${emp.EmployeeFirstName}.${_.first(
                    emp.EmployeeLastName
                )}`
            } else {
                title = data.employee.label
            }
        } else {
            const startTime = data.startDate.format('hh:mm A')
            const endTime = data.endDate.format('hh:mm A')
            // employee Name
            if (renderContent === 'roster') {
                const emp = _.find(this.props.employees, {
                    EmployeeAutoID: employeeId,
                })
                title = `${startTime}-${endTime}:${
                    emp.EmployeeFirstName
                }.${_.first(emp.EmployeeLastName)}`
            } else {
                title = `${data.employee.label}`
            }
        }

        data.title = title

        // otherwise leave

        const payload = this.castToViewModel(data, employeeId)

        const { id } = data
        if (id === '') {
            this.props.actions
                .addEventMulti(payload, employeeId)
                .then(res =>
                    _.head(document.getElementsByClassName('close')).click()
                )
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            //
            payload.dateFrom = this.props.event.dateFrom
            payload.dateTo = this.props.event.dateTo
            this.props.actions
                .updateEvent(payload, employeeId)
                .then(res =>
                    _.head(document.getElementsByClassName('close')).click()
                )
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    handleETimeSubmitMulti = (data, setSubmitting) => {
        const { renderContent } = this.props

        const { id } = data

        let employeeID = null

        let selectedEmployees = null
        if (renderContent === 'roster') {
            if ('' === id) {
                selectedEmployees = this.props.selectedEmployees
            }
        } else {
            selectedEmployees = data.employee
        }

        if (selectedEmployees !== null) {
            employeeID = _.head(selectedEmployees).code
        }

        const actinType = data.actionType.value
        // actionType >= 99 normal
        // otherwise leave
        if (actinType < 99) {
            const start = _.head(data.range)
            const end = _.last(data.range)
            data.startDate = start
            data.endDate = end

            if (!moment(start).isSame(end, 'day')) {
                data.hours = this.props.payrollDefaultWorkHour[employeeID]
            }
        } else {
            const start = _.head(data.range)
            const end = _.last(data.range)
            data.startDate = moment(
                TimeUtils.combineDateNTime(start, data.startTime)
            )
            data.endDate = moment(TimeUtils.combineDateNTime(end, data.endTime))
        }

        const payload = this.castToViewModelMulti(data, selectedEmployees)

        if ('' === id) {
            this.props.actions
                .addEventMulti(payload)
                .then(res =>
                    _.head(document.getElementsByClassName('close')).click()
                )
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            //
            payload.dateFrom = this.props.event.dateFrom
            payload.dateTo = this.props.event.dateTo

            let employeeId = payload.employeeID

            let title = ''
            if (actinType < 99) {
                // format EmployeeName
                if (renderContent === 'roster') {
                    const emp = _.find(this.props.displayEmployees, {
                        EmployeeAutoID: employeeId,
                    })
                    title = `${emp.EmployeeFirstName} ${emp.EmployeeLastName}`
                } else {
                    title = _.head(data.employee).name
                }
            } else {
                const startTime = data.startDate.format('hh:mm A')
                const endTime = data.endDate.format('hh:mm A')
                // employee Name
                if (
                    renderContent === 'roster' ||
                    renderContent === 'workview'
                ) {
                    const emp = _.find(this.props.displayEmployees, {
                        EmployeeAutoID: employeeId,
                    })
                    title = `${startTime}-${endTime}:${emp.EmployeeFirstName} ${emp.EmployeeLastName}`
                } else {
                    title = _.head(data.employee).name
                }
            }

            payload.Title = title

            this.props.actions
                .updateEvent(payload)
                .then(res =>
                    _.head(document.getElementsByClassName('close')).click()
                )
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    onDelete = event => {
        this.handleShow()
    }

    showNotify = () => {
        this.setState({ showNotify: true })
    }

    closeNotify = () => {
        this.setState({ showNotify: false })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.props.event.id, this.props.employee)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    handleActionTypeChange = (e, form) => {
        form.setFieldValue('actionType', e)
        const leave = e.value < 99 ? true : false
        this.setState({ leaveType: leave })
    }

    handleEmployeeChange = (e, form) => {
        form.setFieldValue('employee', e.value)

        if (_.size(e.value) === 1) {
            //startTime, endTime
            const employeeId = _.head(e.value).code
            const { start, finish } = this.getEmployeeDefaultWorkHour(
                employeeId
            )
            if (!_.isEmpty(start)) {
                form.setFieldValue('startTime', start)
            }

            if (!_.isEmpty(finish)) {
                form.setFieldValue('endTime', finish)
            }
        }
    }

    getEmployeeDefaultWorkHour = employeeId => {
        const employeeNormalWorkHours = this.props.payrollNormalWorkHour[
            employeeId
        ]
        if (!_.isEmpty(employeeNormalWorkHours)) {
            // year, month, date
            const evtYear = moment(this.props.event.start).year()
            const evtMonth = moment(this.props.event.start).month()
            const evtDate = moment(this.props.event.start).date()

            // local weekday
            const weekday = moment(this.props.event.start).weekday() + 1

            //PayrollEmpNormalWorkingHourStartTimeHour,PayrollEmpNormalWorkingHourStartTimeMinute

            const startTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeHour${weekday}`
                ]
            const startTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeMinute${weekday}`
                ]

            //[PayrollEmpNormalWorkingHourFinishTimeHour],[PayrollEmpNormalWorkingHourFinishTimeMinute1]
            const finishTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeHour${weekday}`
                ]
            const finishTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeMinute${weekday}`
                ]
            //[PayrollEmpNormalWorkingHourBreakMinute]
            const breakMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourBreakMinute${weekday}`
                ]

            // reset the start, end time
            //[year, month, day, hour, minute, second, millisecond]
            const evtStartTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                startTimeHour,
                startTimeMinute,
            ])
            const evtFinishTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                finishTimeHour,
                finishTimeMinute,
            ])

            // eTimeRequest
            const startTime = TimeUtils.extractTime(evtStartTime.toDate())
            const endTime = TimeUtils.extractTime(evtFinishTime.toDate())

            return { start: startTime, finish: endTime }
        }
        return {}
    }

    handlePeriodChange = (dates, dateStrings, form) => {
        form.setFieldValue('range', dates)
        const a = _.head(dates)
        const b = _.last(dates)
        const days = b.diff(a, 'days')
        if (days >= 1) {
            this.setState({ multipleDays: true })
        } else {
            this.setState({ multipleDays: false })
        }
    }

    onChange = (value, dateString) => {
        console.log('Selected Time: ', value)
        console.log('Formatted Selected Time: ', dateString)
    }
    onOk = value => {
        console.log('onOk: ', value)
    }

    render() {
        const { renderContent } = this.props
        const startDate = moment(this.props.event.dateFrom)
        const endDate = moment(this.props.event.dateTo)

        const initialValues = {
            id: this.props.event.id,
            actionType: this.props.event.actionType,
            range: [startDate, endDate],
            startTime: this.props.event.startTime,
            endTime: this.props.event.endTime,
            duration: this.props.event.duration,
            hours: this.props.event.hours || 0,
            break: this.props.event.break || 0,
            title: this.props.event.Title,
            note: this.props.event.Note,
            employeeID: this.props.event.employeeID,
            existing: this.props.event.existing,
        }

        const showEmployee = this.props.showEmployee
        let employeeOptions = []
        if (showEmployee) {
            const empOption = this.props.displayEmployees.map(emp => {
                let o = {}
                o.name = emp.EmployeeName
                o.code = emp.key
                return o
            })
            employeeOptions = empOption

            if (this.props.event.id !== '') {
                initialValues.employee = _.filter(empOption, {
                    code: this.props.event.employeeID,
                })
            } else if (renderContent === 'roster') {
                initialValues.employee = this.props.selectedEmployees

                const employeeID = _.head(this.props.selectedEmployees).code

                const { start, finish } = this.getEmployeeDefaultWorkHour(
                    employeeID
                )
                initialValues.startTime = start
                initialValues.endTime = finish
            } else {
                initialValues.employee = []
            }
        }

        const { readOnly } = this.state
        return (
            <div>
                <Formik
                    initialValues={initialValues}
                    validate={validate(getValidationSchema)}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            this.handleETimeSubmitMulti(values, setSubmitting)
                        }, 400)
                    }}
                >
                    {etimeForm => (
                        <Form onSubmit={etimeForm.handleSubmit}>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    {showEmployee && (
                                        <div className="row form-group">
                                            <div className="col-sm-4 col-w100">
                                                <label htmlFor="actionType">
                                                    Employee:
                                                </label>
                                            </div>
                                            <div className="col-sm-8">
                                                {/* <EmployeeSelector
                                                    value={
                                                        etimeForm.values
                                                            .employee
                                                    }
                                                    // onChange={
                                                    //     etimeForm.setFieldValue
                                                    // }
                                                    onChange={(e, value) =>
                                                        this.handleEmployeeChange(
                                                            e,
                                                            value,
                                                            etimeForm
                                                        )
                                                    }
                                                    onBlur={
                                                        etimeForm.setFieldTouched
                                                    }
                                                    error={
                                                        etimeForm.errors
                                                            .employee
                                                    }
                                                    touched={
                                                        etimeForm.touched
                                                            .employee
                                                    }
                                                    options={employeeOptions}
                                                    className="dropdownselectEmployee"
                                                    readOnly={readOnly}
                                                /> */}

                                                <MultiSelect
                                                    optionLabel="name"
                                                    value={
                                                        etimeForm.values
                                                            .employee
                                                    }
                                                    options={employeeOptions}
                                                    onChange={e =>
                                                        this.handleEmployeeChange(
                                                            e,
                                                            etimeForm
                                                        )
                                                    }
                                                    maxSelectedLabels={3}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {!this.state.leaveType && (
                                        <div className="row ">
                                            <div className="col-xs-6 col-sm-6 col-md-6 form-group padright15">
                                                <label className="col-xs-4 col-sm-4 col-md-4 control-label">
                                                    Start:
                                                    <span className="text-danger ">
                                                        &nbsp;*&nbsp;
                                                    </span>
                                                </label>
                                                <div className="col-xs-8 col-sm-8 col-md-8">
                                                    {readOnly ? (
                                                        etimeForm.values
                                                            .startTime
                                                    ) : (
                                                        <Field
                                                            id="startTime"
                                                            className="form-control"
                                                            type="time"
                                                            name="startTime"
                                                            onChange={
                                                                etimeForm.handleChange
                                                            }
                                                            onBlur={
                                                                etimeForm.handleBlur
                                                            }
                                                            value={
                                                                etimeForm.values
                                                                    .startTime
                                                            }
                                                            readOnly={readOnly}
                                                        />
                                                    )}

                                                    {/* <p className="help-block">HH:MM</p> */}
                                                </div>
                                            </div>

                                            <div className="col-xs-6 col-sm-6 col-md-6 form-group ">
                                                <label className="col-xs-4 col-sm-4 col-md-4 control-label">
                                                    Until:
                                                    <span className="text-danger">
                                                        &nbsp;*&nbsp;
                                                    </span>
                                                </label>
                                                <div className="col-xs-8 col-sm-8 col-md-8">
                                                    {readOnly ? (
                                                        etimeForm.values.endTime
                                                    ) : (
                                                        <Field
                                                            id="endTime"
                                                            className="form-control"
                                                            type="time"
                                                            name="endTime"
                                                            onChange={
                                                                etimeForm.handleChange
                                                            }
                                                            onBlur={
                                                                etimeForm.handleBlur
                                                            }
                                                            value={
                                                                etimeForm.values
                                                                    .endTime
                                                            }
                                                            readOnly={readOnly}
                                                        />
                                                    )}

                                                    {/* <p className="help-block">HH:MM</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.leaveType && (
                                        <div className="row">
                                            <div className="col-xs-6 col-sm-6 col-md-6 form-group padright15">
                                                <label className="col-xs-3 col-sm-4 col-md-4 control-label">
                                                    Break:{' '}
                                                </label>
                                                <div className="col-xs-8 col-sm-8 col-md-8">
                                                    {readOnly ? (
                                                        etimeForm.values.break
                                                    ) : (
                                                        <Field
                                                            id="break"
                                                            className="form-control"
                                                            type="text"
                                                            name="break"
                                                            onChange={
                                                                etimeForm.handleChange
                                                            }
                                                            onBlur={
                                                                etimeForm.handleBlur
                                                            }
                                                            value={
                                                                etimeForm.values
                                                                    .break
                                                            }
                                                            readOnly={readOnly}
                                                        />
                                                    )}
                                                    {etimeForm.errors.break &&
                                                        etimeForm.touched
                                                            .break && (
                                                            <div className="errorMsg">
                                                                {
                                                                    etimeForm
                                                                        .errors
                                                                        .break
                                                                }
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.leaveType &&
                                        !this.state.multipleDays && (
                                            <div className="row">
                                                <div className="col-xs-6 col-sm-6 col-md-6 form-group padright15">
                                                    <label className="col-xs-3 col-sm-4 col-md-4 control-label">
                                                        Hours:{' '}
                                                        <span className="text-danger">
                                                            &nbsp;*&nbsp;
                                                        </span>
                                                    </label>
                                                    <div className="col-xs-8 col-sm-8 col-md-8">
                                                        {readOnly ? (
                                                            etimeForm.values
                                                                .hours
                                                        ) : (
                                                            <Field
                                                                id="hours"
                                                                className="form-control"
                                                                type="text"
                                                                name="hours"
                                                                onChange={
                                                                    etimeForm.handleChange
                                                                }
                                                                onBlur={
                                                                    etimeForm.handleBlur
                                                                }
                                                                value={
                                                                    etimeForm
                                                                        .values
                                                                        .hours
                                                                }
                                                                readOnly={
                                                                    readOnly
                                                                }
                                                            />
                                                        )}
                                                        {etimeForm.errors
                                                            .hours &&
                                                            etimeForm.touched
                                                                .hours && (
                                                                <div className="errorMsg">
                                                                    {
                                                                        etimeForm
                                                                            .errors
                                                                            .hours
                                                                    }
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    <div className="row">
                                        <div className=" col-sm-12 form-group padright15">
                                            <label className=" col-sm-2 col-md-2 control-label">
                                                Action:{' '}
                                            </label>
                                            <div className="col-sm-10 col-md-10">
                                                {readOnly ? (
                                                    etimeForm.values.actionType
                                                        .label
                                                ) : (
                                                    <div
                                                        style={{
                                                            margin: '0rem 0',
                                                        }}
                                                    >
                                                        <Select
                                                            id="actionType"
                                                            dropdownStyle={{
                                                                zIndex: 1102,
                                                            }}
                                                            // multi={false}
                                                            options={
                                                                this.props
                                                                    .actionTypes
                                                            }
                                                            onChange={e =>
                                                                this.handleActionTypeChange(
                                                                    e,
                                                                    etimeForm
                                                                )
                                                            }
                                                            onBlur={
                                                                etimeForm.handleBlur
                                                            }
                                                            value={
                                                                etimeForm.values
                                                                    .actionType
                                                            }
                                                            // isSearchable={false}
                                                            disabled={readOnly}
                                                        />
                                                        <div className="errorMsg">
                                                            <ErrorMessage name="actionType" />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* <ActionSelector
                                                    value={
                                                        etimeForm.values
                                                            .actionType
                                                    }
                                                    onChange={e => {
                                                        this.handleActionTypeChange(
                                                            e,
                                                            etimeForm
                                                        )
                                                    }}
                                                    onBlur={
                                                        etimeForm.setFieldTouched
                                                    }
                                                    error={
                                                        etimeForm.errors
                                                            .actionType
                                                    }
                                                    touched={
                                                        etimeForm.touched
                                                            .actionType
                                                    }
                                                    options={
                                                        this.props.actionTypes
                                                    }
                                                    readOnly={readOnly}
                                                /> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className=" col-sm-12 form-group5">
                                            <label className=" col-sm-2 col-md-2 control-label">
                                                Job Detail:
                                                {/* <span className="text-danger">
                                                    &nbsp;*&nbsp;
                                                </span>{' '} */}
                                            </label>
                                            <div className="col-sm-10 col-md-10">
                                                {readOnly ? (
                                                    etimeForm.values.note
                                                ) : (
                                                    <textarea
                                                        type="text"
                                                        id="note"
                                                        className="form-control textarea-size"
                                                        placeholder="Enter Job Details"
                                                        onChange={
                                                            etimeForm.handleChange
                                                        }
                                                        onBlur={
                                                            etimeForm.handleBlur
                                                        }
                                                        value={
                                                            etimeForm.values
                                                                .note
                                                        }
                                                        readOnly={readOnly}
                                                    />
                                                )}

                                                <div className="errorMsg">
                                                    <ErrorMessage name="note" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className=" col-sm-12 form-group5">
                                            <label className=" col-sm-2 col-md-2 control-label">
                                                Period:
                                            </label>
                                            <div className="col-sm-10 col-md-10">
                                                {/* <DatePicker.RangePicker
                                                    name="range"
                                                    disabled={readOnly}
                                                    inputReadOnly={true}
                                                    popupStyle={{
                                                        zIndex: 1102
                                                    }}
                                                    onChange={(
                                                        dates,
                                                        dateStrings
                                                    ) =>
                                                        this.handlePeriodChange(
                                                            dates,
                                                            dateStrings,
                                                            etimeForm
                                                        )
                                                    }
                                                /> */}
                                                <RangePicker
                                                    // showTime={{
                                                    //     format: 'HH:mm',
                                                    // }}
                                                    popupStyle={{
                                                        zIndex: 1102,
                                                    }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    onChange={this.onChange}
                                                    onOk={this.onOk}
                                                />
                                                <div className="errorMsg">
                                                    <ErrorMessage name="range" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {readOnly ? (
                                <div />
                            ) : (
                                <div className="modal-footer">
                                    <button
                                        type="submit"
                                        className="btn btn-success pull-left btn-md-w"
                                        disabled={etimeForm.isSubmitting}
                                    >
                                        Save
                                    </button>
                                    {etimeForm.values.existing && (
                                        <button
                                            type="button"
                                            className="btn btn-success pull-left btn-lg-w"
                                            disabled={etimeForm.isSubmitting}
                                            onClick={this.showNotify}
                                        >
                                            Notification
                                        </button>
                                    )}

                                    {etimeForm.values.existing && (
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm-w"
                                            onClick={this.onDelete}
                                        >
                                            Delete
                                        </button>
                                    )}

                                    <div className="modal-sm">
                                        <Modal
                                            show={this.state.show}
                                            onHide={this.handleClose}
                                            dialogClassName="mod-w400"
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title>
                                                    <span>Confirm Delete</span>
                                                </Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <span>Are you sure?</span>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success pull-left btn-sm-w"
                                                        onClick={
                                                            this.removeEvent
                                                        }
                                                    >
                                                        Yes
                                                    </button>

                                                    <button
                                                        type="submit"
                                                        className="btn btn-default btn-sm-w"
                                                        onClick={
                                                            this.handleClose
                                                        }
                                                    >
                                                        No
                                                    </button>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                    </div>

                                    <div className="modal-lg">
                                        <Modal
                                            show={this.state.showNotify}
                                            onHide={this.closeNotify}
                                            dialogClassName="mod-w750"
                                        >
                                            <ModalSMS
                                                handleClose={this.closeNotify.bind(
                                                    this
                                                )}
                                            />
                                        </Modal>
                                    </div>
                                </div>
                            )}
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        displayEmployees: state.roster.displayEmployees,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
        selectedEmployees: state.roster.selectedEmployees,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ETimeForm)
